import React from 'react';
import { StyledWidgetsHero } from './blogHero.styles';

export const BlogHero = ({ category }: { category?: string; }) => {
    return (
        <StyledWidgetsHero>
            <div className="hero-wrapper">
                {category &&
                    <span>{category}</span>
                }
                <h1>Bracket Making Blog</h1>
                <h2>Discover insightful blog articles on brackets, delving into the intricacies of modern bracket makers, their features, and the art of tournament organization.</h2>
            </div>
        </StyledWidgetsHero>
    );
};
